
import { Authtoken, Products, Info } from '../services/auth.js';

export async function ValidateLogin(tokenLocalStorage = "") {
  const uuid_module = "f37e3c72-e4af-4ff7-966f-f7f64cd2ce17";
  var response = {
    token: null,
    auth: false,
    type: null,
    user: null
  };
  
  try {
    var authBearer = {
      acesso: false,
      roles: {},
      user: {}
      };
    var authUrl = false;
    var bearer = "";
    if (tokenLocalStorage) {
      authBearer = await Products(tokenLocalStorage);
      if (!authBearer.acesso) {
        return ValidateLogin();
      }
    } else {
      var token = window.location.href.split("?token=")[1];
      var res = await Authtoken(token);
      bearer = res.access_token;
      authUrl = res.product_uuid === uuid_module;
    }
    if (authUrl) {
      response.type = "url";
      response.token = bearer;
      response.auth = true;
      response.user = await Info(bearer);
      const roles = await Products(bearer);
      console.log('roles', roles)
      response.roles = roles.roles;
    } else if (authBearer.acesso) {
      response.type = "bearer";
      response.auth = true;
      response.user = await Info(tokenLocalStorage);
      response.roles = authBearer.roles;
    }  else {
      response.auth = false;
    }
  
  } catch(error) { }
  return response;
}

